<template lang="pug">
v-expansion-panel-title
  span
    v-icon.mr-5 {{ icon }}
    | {{ title }}
</template>

<script setup>
defineOptions({
  name: 'PersonExpansionPanelHeader',
})

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
})
</script>
